import { useCallback } from 'react'
import * as React from 'react'

import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import type { DetailItemCardVariant } from '../common/types'
import ExperienceCtaContent from '../CTAContent/ExperienceCtaContent'
import { PlannedItemPriceContent } from './PlannedItemPriceContent'

import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'
import type { ExperienceItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import { isExperienceAvailable } from 'tripPlanner/utils/experience'

interface Props {
  item: ExperienceItem
  experience: App.ExperienceOffer
  variant: DetailItemCardVariant
}

function ExperiencePriceAndCTAs({
  item,
  experience,
  variant,
}: Props) {
  const trackEvent = useTrackExperienceOfferEvent()
  const handleExperienceClick = useCallback(() => {
    if (experience) {
      trackEvent('OFFER_TILE_CLICKED', [
        {
          type: 'click',
          data: {
            offer: experience,
          },
        },
      ])
    }
  }, [experience, trackEvent])

  let priceAreaContent: React.ReactElement | null = null
  let offerLink: string | undefined = undefined
  let isOfferAvailable = true

  if (isLeBookmark(item)) {
    offerLink = buildProductLink(item, { experience }) ?? ''

    isOfferAvailable = experience ?
        isExperienceAvailable(experience) :
      true

    const { price, currencyCode } = item.savedItemData
    priceAreaContent = (
      <PlannedItemPriceContent
        price={price}
        currencyCode={currencyCode}
        isOfferAvailable={isOfferAvailable}
      />
    )
  }

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      <div className="cta-area">
        <ExperienceCtaContent
          item={item}
          variant={variant}
          offerLink={offerLink}
          isOfferAvailable={isOfferAvailable}
          onViewOffer={handleExperienceClick}
        />
      </div>
    </ItemPriceAndCTAs>
  )
}

export default ExperiencePriceAndCTAs
